var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon radio-icon",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .icon__outline {fill-rule:evenodd;clip-rule:evenodd;fill:currentColor;}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon__mark radio-icon__mark",
    d: "M16,6.37c5.32,0,9.63,4.31,9.63,9.63s-4.31,9.63-9.63,9.63S6.37,21.32,6.37,16S10.68,6.37,16,6.37z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon__outline",
    d: "M16,2.65c7.36,0,13.35,5.99,13.35,13.35S23.36,29.35,16,29.35S2.65,23.36,2.65,16S8.64,2.65,16,2.65 M16,0       C7.16,0,0,7.16,0,16s7.16,16,16,16s16-7.16,16-16S24.84,0,16,0L16,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRadio);
export default __webpack_public_path__ + "static/media/icon-radio.9ede1d9382306ca2c9e27ffb0d302540.svg";
export { ForwardRef as ReactComponent };